import { apiClient } from './ApiClient';

export type DeviceType = {
  name: string;
  createdAt?: string;
};

type DeviceTypesResponse = {
  types: DeviceType[];
};

export const getDeviceTypes = async (): Promise<DeviceType[]> => {
  const response = await apiClient
    .getClient()
    .get<DeviceTypesResponse>(`device/types`);
  return response.data.types;
};
